import React, { useEffect, useState } from 'react'
import { Grid, IconButton } from '@mui/material'
import { Info } from '@mui/icons-material'
import { connect } from 'react-redux'
import FuelRequestComplete from '../../../../components/fuel_request/completed'
import * as local from '../../../../appRedux/actions/fuel_request/local'
import SalesDetails from '../../../../components/sales_details'
import BlankPage from '../../../../components/blank_page'
import IntlMessages from '../../../../util/IntlMessages'
import Comeback from '../../../../components/comeback'
import * as router from '../../../../constants/router'
import * as constants from '../../../../constants'

function Local(props) {
    const [showDetails, setShowDetails] = useState(false)

    useEffect(() => {
        props.operatorFuelRequestHistoryLocalAction()
    }, [])

    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={6} md={6}>
                    <Comeback title={<IntlMessages id="localSale" />} redirectLink={router.SALES} />
                </Grid>
                <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
                    <IconButton onClick={() => setShowDetails(!showDetails)}>
                        <Info />
                    </IconButton>
                </Grid>
            </Grid>
            {props.list.length === 0 ?
                <BlankPage type={constants.BLANK_PAGE_FUEL_REQUEST_LOCAL} />
                : props.list.map((fuelRequestDetails, index) => (
                    <FuelRequestComplete type="local" key={index} {...fuelRequestDetails} />
                ))
            }
            <br />
            <br />
            <br />
            <SalesDetails
                type="local"
                showDetails={showDetails}
                setShowDetails={() => setShowDetails(!showDetails)} />
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        list: state.field.list
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        operatorFuelRequestHistoryLocalAction: () => dispatch(local.operatorFuelRequestHistoryLocalAction())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Local)
